import React from 'react';

import { NativeResources } from '@ariksa/inventory-core/api';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { formatTooltip } from 'components/DataDisplay';
import { ContainerIcon } from 'components/Icons';
import { SummaryCard } from 'containers/Dashboard/utils/SummaryCard';
import { getVulnerabilityCountInfo } from 'containers/Dashboard/VulnerabilityOverview/Components/utils';

import { selectVulnerabilityOverview } from '../selectors';

export const Containers: React.FC = () => {
  const { vulnerabilitiesCount } = useSelector(selectVulnerabilityOverview);
  const { data, isLoading } = vulnerabilitiesCount.container;
  const navigate = useNavigate();

  return (
    <SummaryCard
      label="In Containers"
      icon={<ContainerIcon />}
      change={{
        isLoading: isLoading,
        first: data.previous_count,
        last: data.current_count,
        percentChange: data.percentage_change,
      }}
      cloudProviders={[]}
      count={data.current_count ?? 0}
      isLoading={isLoading}
      onClick={() =>
        navigate(
          '/visibility/vulnerability?show=Details&tab=' +
            NativeResources.ElasticContainerService,
        )
      }
      info={{
        message: getVulnerabilityCountInfo(data.vulnerability_count),
        enabled: false,
      }}
      labelTooltip={formatTooltip({
        header: 'Containers',
        content:
          'Vulnerabilities in Containers deployed in VMs, Kubernetes and cloud-native PaaS such as ECS',
        width: 48,
      })}
    />
  );
};
